<div class="zoom-tooltip-container"
     (dbClickOutside)="opened && close.emit()">
  <db-tooltip-option [options]="options.firstSection"></db-tooltip-option>
  <div class="separator"></div>
  <db-tooltip-option [options]="options.secondSection"></db-tooltip-option>
</div>
